import * as React from "react";
const SvgRandstadLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M11 17H9v-6.111c0-.92-.672-1.667-1.5-1.667H2V7h5.028c.28 0 .533.123.713.328l2.964 3.293c.184.2.295.48.295.792zM13 17h2v-6.111c0-.92.672-1.667 1.5-1.667H22V7h-5.028a.94.94 0 0 0-.713.328l-2.964 3.293c-.184.2-.295.48-.295.792z" }));
export default SvgRandstadLine;
